
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    FEATURES_TAB_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery } from 'Core/data/GraphQLApi';
import { featureTabResult } from 'Redux/actions';


function* getDevice({ payload }) {
    try {
        const QUERY = `
            query getUnit ($id: Int!) {
                result: getUnit (id: $id) {
                    id
                    companyId
                    label
                    esn
                    imei
                    reference
                    deviceCategory
                    promiles
                    promilesOdometerCalculated
                    comdata
                    apu
                    hybrid
                    vbus
                    jbus
                    pressurePro
                    battery
                    useEcuOdometer
                    useEcuEngineHours
                    useEcuSpeed
                    useEcuVin
                    driverBehavior
                    show
                    analytics
                    timezoneId
                    cariq
                    carb
                    deviceModel {
                        id
                        name
                        manufacturerId
                        manufacturer {
                            id
                            name
                        }
                        product
                        geofence
                        input
                        output
                        ota
                        sms
                        starter
                        driverBehavior
                        battery
                        analytic
                        promiles
                        comData
                        pressurePro
                        vbus
                        jbus
                        obd2Alerts
                        motion
                        tow
                        ttu
                        cariq
                        hoursEnable
                        odometerEnable
                        carbEnable
                    }
                    tags
                }
            }
        `;
        
        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );
        
        if(data?.result){
            yield put(featureTabResult(data?.result))
        }
    } catch (exc) {
        yield put(featureTabResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/featureTab/redux/saga",
            "getDevice",
        )
    }
}

function* watchMethods() {
    yield takeEvery(FEATURES_TAB_REQUEST, getDevice);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}